import React from 'react';
import { Flex } from 'antd';

import { ChatListContainer } from 'features/analytics/features/ChatList/containers/ChatListContainer';

import { ModerationContainer } from './containers/ModerationContainer';
import { useAppSelector } from '../../../../store';
import { ModerationChart } from './components/ModerationChart';
import { selectAnalyticsFilters } from '../../store/analyticFiltersSlice';

export const AnalyticModeration = () => {
    const { chat } = useAppSelector(selectAnalyticsFilters);

    return (
        <Flex gap={16} vertical>
            <Flex gap={16} justify={'space-between'} wrap={'wrap'}>
                <Flex flex='0 0 50%'>
                    <ModerationChart />
                </Flex>
            </Flex>

            {chat ? <ModerationContainer /> : <ChatListContainer />}
        </Flex>
    );
};
